export default __webpack_public_path__ + "static/media/lowFee.4ebb26e0.png";